import styled from '@emotion/styled';

export type PageProps = {
  fullWidth?: boolean;
};

export const Page = styled.main<PageProps>`
  ${({ fullWidth }) => `
    width: 100%;
    max-width: ${fullWidth ? '100%' : '1920px'};
  `}
`;
